import { render, staticRenderFns } from "./ms-select-dicNew.vue?vue&type=template&id=5cef5b40"
import script from "./ms-select-dicNew.vue?vue&type=script&lang=js"
export * from "./ms-select-dicNew.vue?vue&type=script&lang=js"
import style0 from "./ms-select-dicNew.vue?vue&type=style&index=0&id=5cef5b40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports